<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-mute`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.828 2.243a1 1 0 000 1.414l39.598 39.598a1 1 0 001.415 0l1.414-1.414a1 1 0 000-1.414l-4.646-4.646-2.837-2.838-2.846-2.845-2.868-2.869L27 22.172l-4-4-4.027-4.028-2.853-2.852L5.657.829a.999.999 0 00-1.414 0L2.828 2.243zM10 16.985c0-.513.197-1.003.543-1.371L14 19.071V30.03l9 6.923v-8.882l4 4V40a2 2 0 01-2 2h-1.32c-.441 0-.87-.146-1.219-.415L10.781 32.6A1.997 1.997 0 0110 31.015v-14.03zm13-3.056v-2.882L21.371 12.3l-2.853-2.853 3.943-3.032A1.997 1.997 0 0123.68 6H25a2 2 0 012 2v9.929l-4-4zm13.424 13.424L33 23.929a5.979 5.979 0 00-1.463-3.855c-.391-.452-.438-1.146-.016-1.568l1.387-1.386c.371-.372.972-.396 1.334-.015A9.964 9.964 0 0137 24a9.982 9.982 0 01-.576 3.353zm5.974 5.974l-2.938-2.938A13.94 13.94 0 0041 24c0-3.736-1.463-7.13-3.848-9.64-.393-.415-.412-1.072-.008-1.476l1.408-1.408a.96.96 0 011.369-.008A17.94 17.94 0 0145 24c0 3.415-.951 6.607-2.602 9.327zM4 16a1 1 0 00-1 1v14a1 1 0 001 1h2a1 1 0 001-1V17a1 1 0 00-1-1H4z"/></svg>
</template>
<script>

export default {
  name: 'IconMute',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
